import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";

import { wsAlertMaintenanceToggleActiveParm } from "./wsAlertMaintenanceAlertInfo";
import { wsAlertMaintenanceBroadcastAlertUpdateValidateParm } from "./wsAlertMaintenanceAlertInfo";
import { wsAlertMaintenanceBroadcastAlertAddParm } from "./wsAlertMaintenanceBroadcastAlertInfo";
import { wsAlertMaintenanceBroadcastAlertEditParm } from "./wsAlertMaintenanceBroadcastAlertInfo";
import { wsAlertMaintenanceBroadcastAlertAddInsertParm } from "./wsAlertMaintenanceBroadcastAlertInfo";
import { wsAlertMaintenanceBroadcastAlertAddUpdateParm } from "./wsAlertMaintenanceBroadcastAlertInfo";
import { wsAlertMaintenanceSpecialAlertEditParm } from "./wsAlertMaintenanceSpecialAlertInfo";
import { wsAlertMaintenanceSpecialAlertUpdateParm } from "./wsAlertMaintenanceSpecialAlertInfo";
import { wsAlertMaintenanceEventAlertGetDataParm } from "./wsAlertMaintenanceEventAlertInfo";
import { wsAlertMaintenanceEventAlertAddParm } from "./wsAlertMaintenanceEventAlertInfo";
import { wsAlertMaintenanceEventAlertUpdateParm } from "./wsAlertMaintenanceEventAlertInfo";
import { wsAlertMaintenanceIncidentAlertGetDataParm } from "./wsAlertMaintenanceIncidentAlertInfo";
import { wsAlertMaintenanceIncidentAlertAddParm } from "./wsAlertMaintenanceIncidentAlertInfo";
import { wsAlertMaintenanceIncidentAlertUpdateParm } from "./wsAlertMaintenanceIncidentAlertInfo";

@Injectable()
export class DataService_AlertMaintenance {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	AlertMaintenanceAlertSelectList
	//
	//-----------------------------------------------------------------------------------------------------
	AlertMaintenanceAlertSelectList(SchoolID: number) {
		var postResult$ = new Subject();
		var url = "SchoolSetupDiscipline/AlertMaintenanceAlertSelectList";

		var promise$ = this.httpclientService.post(url, SchoolID);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	AlertMaintenanceBroadcastAlertAddDataGet
	//
	//-----------------------------------------------------------------------------------------------------
	AlertMaintenanceBroadcastAlertAddDataGet(parm: wsAlertMaintenanceBroadcastAlertAddParm) {
		var postResult$ = new Subject();
		var url = "SchoolSetupDiscipline/AlertMaintenanceBroadcastAlertAddDataGet";

		var promise$ = this.httpclientService.post(url, parm);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	AlertMaintenanceBroadcastAlertEditDataGet
	//
	//-----------------------------------------------------------------------------------------------------
	AlertMaintenanceBroadcastAlertEditDataGet(parm: wsAlertMaintenanceBroadcastAlertEditParm) {
		var postResult$ = new Subject();
		var url = "SchoolSetupDiscipline/AlertMaintenanceBroadcastAlertEditDataGet";

		var promise$ = this.httpclientService.post(url, parm);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	AlertMaintenanceBroadcastAlertInsert
	//
	//-----------------------------------------------------------------------------------------------------
	AlertMaintenanceBroadcastAlertInsert(parms: wsAlertMaintenanceBroadcastAlertAddInsertParm) {
		var postResult$ = new Subject();
		var url = "SchoolSetupDiscipline/AlertMaintenanceBroadcastAlertInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	AlertMaintenanceBroadcastAlertUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	AlertMaintenanceBroadcastAlertUpdate(parms: wsAlertMaintenanceBroadcastAlertAddUpdateParm) {
		var postResult$ = new Subject();
		var url = "SchoolSetupDiscipline/AlertMaintenanceBroadcastAlertUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	AlertMaintenanceToggleActive
	//
	//-----------------------------------------------------------------------------------------------------
	AlertMaintenanceToggleActive(parms: wsAlertMaintenanceToggleActiveParm) {
		var postResult$ = new Subject();
		var url = "SchoolSetupDiscipline/AlertMaintenanceToggleActive";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	AlertMaintenanceBroadcastAlertUpdateValidate
	//
	//-----------------------------------------------------------------------------------------------------
	AlertMaintenanceBroadcastAlertUpdateValidate(parms: wsAlertMaintenanceBroadcastAlertUpdateValidateParm) {
		var postResult$ = new Subject();
		var url = "SchoolSetupDiscipline/AlertMaintenanceBroadcastAlertUpdateValidate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	AlertMaintenanceSpecialAlertEditDataGet
	//
	//-----------------------------------------------------------------------------------------------------
	AlertMaintenanceSpecialAlertEditDataGet(parms: wsAlertMaintenanceSpecialAlertEditParm) {
		var postResult$ = new Subject();
		var url = "SchoolSetupDiscipline/AlertMaintenanceSpecialAlertEditDataGet";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	AlertMaintenanceSpecialAlertUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	AlertMaintenanceSpecialAlertUpdate(parms: wsAlertMaintenanceSpecialAlertUpdateParm) {
		var postResult$ = new Subject();
		var url = "SchoolSetupDiscipline/AlertMaintenanceSpecialAlertUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	AlertMaintenanceEventAlertDataGet
	//
	//-----------------------------------------------------------------------------------------------------
	AlertMaintenanceEventAlertDataGet(parms: wsAlertMaintenanceEventAlertGetDataParm) {
		var postResult$ = new Subject();
		var url = "SchoolSetupDiscipline/AlertMaintenanceEventAlertDataGet";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	AlertMaintenanceEventAlertAdd
	//
	//-----------------------------------------------------------------------------------------------------
	AlertMaintenanceEventAlertAdd(parms: wsAlertMaintenanceEventAlertAddParm) {
		var postResult$ = new Subject();
		var url = "SchoolSetupDiscipline/AlertMaintenanceEventAlertAdd";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	AlertMaintenanceEventAlertUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	AlertMaintenanceEventAlertUpdate(parms: wsAlertMaintenanceEventAlertUpdateParm) {
		var postResult$ = new Subject();
		var url = "SchoolSetupDiscipline/AlertMaintenanceEventAlertUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	AlertMaintenanceIncidentAlertDataGet
	//
	//-----------------------------------------------------------------------------------------------------
	AlertMaintenanceIncidentAlertDataGet(parms: wsAlertMaintenanceIncidentAlertGetDataParm) {
		var postResult$ = new Subject();
		var url = "SchoolSetupDiscipline/AlertMaintenanceIncidentAlertDataGet";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	AlertMaintenanceIncidentAlertAdd
	//
	//-----------------------------------------------------------------------------------------------------
	AlertMaintenanceIncidentAlertAdd(parms: wsAlertMaintenanceIncidentAlertAddParm) {
		var postResult$ = new Subject();
		var url = "SchoolSetupDiscipline/AlertMaintenanceIncidentAlertAdd";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	AlertMaintenanceIncidentAlertUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	AlertMaintenanceIncidentAlertUpdate(parms: wsAlertMaintenanceIncidentAlertUpdateParm) {
		var postResult$ = new Subject();
		var url = "SchoolSetupDiscipline/AlertMaintenanceIncidentAlertUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
}
